import EmailSignup from './email-signup';
import EmailVerification from './email-verification';
import ResetPassword from './reset-password';
import SharePersonaUseCase from './share-persona-use-case';
import ShareSignupSignin from './share-signup-signin';
import ShareSuggestedWorkspaces from './share-suggested-workspaces';

// screens
export const SHARE_SIGNUP_SIGNIN = 'share-signup-signin';
export const EMAIL_SIGN_UP = 'email-sign-up';
export const EMAIL_VERIFICATION = 'email-verification';
export const PERSONA_USE_CASE = 'persona-use-case';
export const SUGGESTED_WORKSPACES = 'suggested-workspaces';
export const RESET_PASSWORD = 'reset-password';

export const SIGN_UP = 'Sign up';
export const SIGN_IN = 'Sign in';

export const MAP_SCREEN_KEY_TO_COMPONENT = {
  [SHARE_SIGNUP_SIGNIN]: ShareSignupSignin,
  [EMAIL_SIGN_UP]: EmailSignup,
  [EMAIL_VERIFICATION]: EmailVerification,
  [SUGGESTED_WORKSPACES]: ShareSuggestedWorkspaces,
  [PERSONA_USE_CASE]: SharePersonaUseCase,
  [RESET_PASSWORD]: ResetPassword,
};
